const html = require('choo/html')
const Icon = require('./icon.js')

module.exports = function ButtonIcon (args) {
  const {
    id=null,
    type = 'square',
    size = 'medium',
    color = 'mediumgrey',
    noIconBackground = false,
    icon = null,
    tooltip = false,
    selected = false,
    disabled = false,
    pickable = false,
    highlighted = false,
    onClick = () => false,
    onMouseDown = () => false,
    onMouseUp = () => false,
    onMouseOver = () => false,
    margin = false,
    hidden = false
  } = args
  const idString = id ? id : ''
  const marginClass = margin ? 'margin' : ''
  const selectedClass = selected ? 'selected' : ''
  const disabledClass = disabled ? 'disabled' : ''
  const iconBackgroundClass = noIconBackground ? 'no-background' : ''
  const pickableClass = pickable ? 'pickable' : ''
  const tooltipClass = tooltip ? 'tooltip' : ''
  const highlightClass = highlighted ? 'highlighted' : ''
  const hiddenClass = hidden ? 'hidden' : ''
  const tooltipText =
    tooltip ? html`<div class="tooltiptext">${tooltip}</div>` : ''
  const classString = `${type} ${size} ${color} 
    ${selectedClass} ${disabledClass} ${pickableClass} ${tooltipClass} 
    ${marginClass} ${highlightClass} ${hiddenClass}`
  return html`
    <button
      id=${idString}
      onclick=${onClick}
      onmousedown=${onMouseDown}
      onmouseup=${onMouseUp}
      onmouseover=${onMouseOver}
      class="${classString}"
      >
      <span class="icon ${iconBackgroundClass}">
        ${Icon({ iconName: icon })}
      </span>
      ${tooltipText}
    </button>
  `
}
